// CSVファイルにしたいデータを配列で渡し、ダウンロードさせる。
export function downloadCsv(records, filename) {
  const bom = new Uint8Array([0xef, 0xbb, 0xbf])
  const data = records.join('\r\n')
  const blob = new Blob([bom, data], { type: 'text/csv' })

  var downloadLink = document.createElement('a')
  downloadLink.download = filename
  downloadLink.href = URL.createObjectURL(blob)
  downloadLink.dataset.downloadurl = ['text/plain', filename, downloadLink.href].join(':')
  downloadLink.click()
}

export function getURLFromBase64(mimeType = '', base64 = '') {
  const bin = atob(base64.replace(/^.*,/, ''))
  const buffer = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i)
  }
  const blob = new Blob([buffer.buffer], {
    type: mimeType
  })
  const url = window.URL.createObjectURL(blob)
  return url
}

export function getArrangedDataSize(dataSize) {
  dataSize = Number(dataSize)
  var unit = ['B', 'KB', 'MB', 'GB']
  var counter = 0
  for (let index = 1; index < 4; index++) {
    if (dataSize >= 1024) {
      counter++
      dataSize /= 1024
    } else {
      break
    }
  }
  return dataSize.toFixed(1) + unit[counter]
}
